exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vgt-table td, .vgt-table th {\n    padding: 2px !important;\n    font-size: 12px;\n}\n#vgt-table {\n    min-height: 100px;\n}\n", ""]);

// exports
